<template>
  <ElevatedCard :compact="compact" class="flex flex-col gap-2 border-gray-50">
    <div class="flex items-start justify-between gap-2">
      <span class="font-bold text-body-xl">{{ title }}</span>
      <span
        v-if="badge"
        class="bg-lime-200 text-lime-900 text-xs font-semibold px-3 py-1 rounded-full shrink-0"
      >
        {{ badge }}
      </span>
    </div>
    <p class="text-sm text-gray-500">{{ description }}</p>
    <!--@slot The call to action rendered at the bottom of the card.-->
    <slot />
  </ElevatedCard>
</template>

<script setup lang="ts">
const { compact = false } = defineProps<{
  title: string
  description: string
  badge?: string
  /** Tighter elevation, used for the stacked cards inside the buy box. */
  compact?: boolean
}>()
</script>
